import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import {
  CUSTOMER_LOCALE_CODES,
  DEFAULT_CUSTOMER_LOCALE,
  detectCustomerLocale,
  persistCustomerLocale,
} from './locales';
import es from './locales/es.json';
import en from './locales/en.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import de from './locales/de.json';

const resources = {
  es: { translation: es },
  en: { translation: en },
  pt: { translation: pt },
  zh: { translation: zh },
  de: { translation: de },
};

const initialLng = detectCustomerLocale();

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: initialLng,
    fallbackLng: DEFAULT_CUSTOMER_LOCALE,
    supportedLngs: CUSTOMER_LOCALE_CODES,
    interpolation: { escapeValue: false },
    returnNull: false,
    react: { useSuspense: false },
  });
  persistCustomerLocale(initialLng);
}

i18n.on('languageChanged', (lng) => {
  persistCustomerLocale(lng);
});

export default i18n;
